var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"custom-tooltip"},_vm._l((this.data.errorColumn),function(data,index){return _c('div',{key:index},[_c('strong',[_vm._v("Field: "+_vm._s(data.columnName))]),_c('br'),_c('span',{staticClass:"mb-2"},[_vm._v("Note: "+_vm._s(data.toolTip))]),_c('br'),_c('br')])}),0):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }